<template>
	<div :id="id" :class="`${right ? 'right-0' : ''} ${up ? 'bottom-8' : ''} absolute z-50 hidden flex-col border rounded-lg bg-gray-50 dark:bg-gray-950 border-gray-200 dark:border-gray-800 mt-3 p-2 gap-1 shadow-lg dark:shadow-gray-900 max-h-72 overflow-y-auto dropdown-list`" @click.stop="">
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	id:string,
	up?:boolean,
	right?:boolean,
}>()
</script>
